import { withTranslation } from "react-i18next";
import {  useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { ClockIcon } from "@heroicons/react/24/outline";


function CardMyApplication({ t, completion, hspipelines, type }) {
    const navigate = useNavigate();
    const [stageName, setStageName] = useState(null);
    const [filterValues, setFilterValues] = useState([]);

    useEffect(() => {
        if (hspipelines && completion.pipelineId) {
            const pipeline = hspipelines.find(p => p.id === completion.pipelineId);
            if (pipeline) {
                const stage = pipeline.stages?.find(s => s.id === completion.hs_pipeline_stage);
                setStageName(stage?.label || null);
            }
        }

        if (type?.filters?.length > 0) {
            const vals = type.filters.map(f => {
                let value = completion.properties?.hasOwnProperty(f.name) ? completion.properties[f.name] : null;
                const option = f.options?.find(o => o.value === value);
                if (option) value = option.label;
                return { name: f.name, value };
            }).filter(f => f.value !== null && f.value !== "" && f.value !== undefined);
            setFilterValues(vals);
        }
    }, [completion, hspipelines, type]);

    const apiStep = completion.step ?? 0;
    const totalSteps = completion.steps?.length ?? 0;
    const isWaiting = completion?.finishedInfo?.finished || (totalSteps > 0 && apiStep >= totalSteps);

    const creationDate = completion.objectAssociated?.creationDate
        ? new Date(completion.objectAssociated.creationDate).toLocaleDateString("fr-FR", {
              day: "numeric",
              month: "long",
              year: "numeric",
          })
        : null;

    const completedSteps = isWaiting ? totalSteps : apiStep;
    const progressPercent = totalSteps > 0 ? Math.round((completedSteps / totalSteps) * 100) : 0;

    return (
        <div className="bg-white rounded-2xl border border-gray-100 shadow-sm p-5 flex items-center justify-between gap-4" style={{ borderColor: '#eceef2', borderRadius: '20px', boxShadow: 'rgba(16, 20, 34, 0.15) 0px 12px 30px -20px' }}>
            <div className="flex-1 min-w-0">
                <div className="flex items-center gap-3 mb-2">
                    <span
                        className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium border"
                        style={isWaiting ? {
                            borderColor: "#e5e7eb",
                            color: "#6b7280",
                            backgroundColor: "#f9fafb",
                        } : {
                            borderColor: "color-mix(in srgb, var(--primary-color) 30%, white)",
                            color: "var(--primary-color)",
                            backgroundColor: "color-mix(in srgb, var(--primary-color) 8%, white)",
                        }}
                    >
                        {stageName ?? t("En cours")}
                    </span>
                    {creationDate && (
                        <span className="text-xs text-gray-400">
                            {t("Créée le")} {creationDate}
                        </span>
                    )}
                </div>

                <h2 className="font-bold text-gray-900 text-lg truncate mb-1">
                    {completion.label ?? "—"}
                </h2>

                {filterValues.length > 0 && (
                    <p className="text-sm text-gray-500 mb-3">
                        {filterValues.map(f => f.value).join(" · ")}
                    </p>
                )}

                {isWaiting ? (
                    <div className="flex items-center gap-1.5 text-sm font-medium" style={{ color: "#d97706" }}>
                        <ClockIcon className="h-4 w-4 flex-shrink-0" />
                        {t("En attente de validation par l'établissement")}
                    </div>
                ) : (
                    <div className="flex items-center gap-3">
                        <div className="flex-1 max-w-xs bg-gray-100 rounded-full h-1.5">
                            <div
                                className="h-1.5 rounded-full transition-all"
                                style={{
                                    width: `${progressPercent}%`,
                                    backgroundColor: "var(--primary-color)",
                                }}
                            />
                        </div>
                        <span className="text-xs text-gray-400 whitespace-nowrap">
                            {totalSteps > 0
                                ? `${t("Étape")} ${Math.min(apiStep, totalSteps)}/${totalSteps}`
                                : null}
                        </span>
                    </div>
                )}
            </div>

            <div className="flex-shrink-0">
                <button
                    onClick={() => navigate("/" + completion.id)}
                    className="px-5 py-2.5 text-sm font-semibold transition-opacity hover:opacity-90"
                    style={isWaiting ? {
                        backgroundColor: "white",
                        color: "gray",
                        border: "1px solid #e7eaef",
                        borderRadius: "11px",
                    } : {
                        backgroundColor: "var(--primary-color)",
                        color: "#fff",
                        borderRadius: "11px",
                    }}
                >
                    {isWaiting ? t("Voir le récapitulatif") : t("Continuer")}
                </button>
            </div>
        </div>
    );
}

export default withTranslation()(CardMyApplication);